import React from 'react';
import {observer} from 'mobx-react';
import {Modal} from 'components/modals';
import {GoalForm} from 'performance_goals/components';

const EditGoalModal = observer(({uiState}) => {
  const {editingGoal, errors} = uiState;
  if (!editingGoal) return null;

  return (
    <Modal
      size='md'
      isOpen={uiState.editGoalModalOpen}
      onHide={() => uiState.closeEditGoalModal()}
      header='goals.Edit Goal'
      subHeader={editingGoal.titleView}>
      <GoalForm
        uiState={uiState}
        goal={editingGoal}
        errors={errors}
        onSave={() => uiState.saveGoal()}
        onCancel={() => uiState.closeEditGoalModal()}
      />
    </Modal>
  );
});

export default EditGoalModal;
